import { RootState } from 'store/index';

export const getErrorStatus = (state: RootState) => state.status.error;
export const getSuccessStatus = (state: RootState) => state.status.success;
export const getErrorMessage = (state: RootState) => state.status.errorMessage;
